import { TextField, MenuItem, type SxProps, type Theme } from "@mui/material";

interface ComboBoxOption {
    value: string | number;
    label: string;
}

interface ComboBoxProps {
    options: ComboBoxOption[];
    title: string;
    value?: string | number;
    onChange?: (value: string) => void;
    sx?: SxProps<Theme>;
}

const ComboBox: React.FC<ComboBoxProps> = ({ options, title, value, onChange, sx }) => {
    return (
        <TextField
            select
            label={title}
            value={value ?? 'Todos'}
            variant="standard"
            onChange={(e) => onChange?.(String(e.target.value))}
            sx={[
                { mb: 2, ml: 1.25, minWidth: '12.5rem', textAlign: 'left' },
                ...(sx ? [sx] : []),
            ]}
        >
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default ComboBox;
